import { Group, Text, ThemeIcon } from "@mantine/core";

// Modal başlık iskeleti: ikon + başlık + tek satır bağlam. Panelde birden çok modal (AccountModal,
// CategoryFormModal, ProductFormModal) aynı üçlüyü elle kuruyor; buraya taşındı ki tek pencereye
// indirilen görsel yükleme akışı iki adımında da BİREBİR aynı başlığı göstersin — başlık adımdan
// adıma oynarsa pencere yer değiştirmiş gibi duruyor.
//
// Diğer modaller henüz taşınmadı; bu dosyaya dokunan onları da geçirebilir.
export function ModalTitle({ icon: Icon, title, description }) {
  return (
    <Group gap="sm" wrap="nowrap">
      <ThemeIcon variant="light" color="chocolate" radius="md" size="lg">
        <Icon size={20} />
      </ThemeIcon>
      <div>
        <Text fw={600}>{title}</Text>
        {description && (
          <Text size="xs" c="dimmed">
            {description}
          </Text>
        )}
      </div>
    </Group>
  );
}
